import React from 'react';
import Typewriter from 'typewriter-effect';

const About = () => {
    return (
    <>
        <h1 className='typewriter-container'>
        <Typewriter
            options={{
                strings: ['Software Engineer', 'Data Analyst', 'Entrepreneur'],
                autoStart: true,
                loop: true,
            }}
        />
        </h1>
        <section className='about-grid'>
        <div className='about-photo'>
        <img src={require (`../images/avatar.svg`)} alt='project' />
        </div>
        <div className='about-description'>
            <h1>About Me</h1>
            <p>I am a Software Engineer with a focus on building interactive and impactful applications. Guided by my background in entrepreneurship, business development, and data analytics but seek challenges and solutions through computation and digital media.</p>
            <p>I maintain my enthusiasm for&nbsp;
            <a href='https://github.com/COVID-19-electronic-health-system/Corona-tracker' target='_blank' rel="noopener noreferrer">an open-source development,</a>&nbsp;
            <a href='https://livecode.nyc/' target='_blank' rel="noopener noreferrer">creative coding,</a>&nbsp;and&nbsp;<a href='https://the-collab-lab.codes/' target='_blank' rel="noopener noreferrer">mentoring.</a>
            </p>
        </div>
        </section>
    </>
    )
}

export default About;
